import { IButtonProps, PrimaryButton as FabricPrimaryButton, Spinner } from "@fluentui/react";
import React, { useState } from "react";

export type PrimaryButtonProps = Pick<IButtonProps, "disabled" | "styles"> & {
    text: string;
    type?: "loading";
    testId?: string;
    onClick?(): void | Promise<void>;
};

export const PrimaryButton: React.VFC<PrimaryButtonProps> = ({
    text,
    type,
    disabled,
    styles,
    testId,
    onClick
}: PrimaryButtonProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const callOnClickAsync = async () => {
        if (onClick) {
            setIsLoading(true);

            try {
                await onClick();
            } finally {
                setIsLoading(false);
            }
        }
    };

    if (type === "loading") {
        return (
            <FabricPrimaryButton
                disabled={disabled || isLoading}
                data-testId={testId}
                onClick={callOnClickAsync}
                styles={{ root: { width: 90 }, ...styles }}
                text={isLoading ? undefined : text}
            >
                {isLoading && <Spinner hidden={false} styles={{ root: { padding: 0 } }} />}
            </FabricPrimaryButton>
        );
    }

    return (
        <FabricPrimaryButton
            disabled={disabled || isLoading}
            data-testId={testId}
            onClick={onClick}
            styles={{ root: { width: 90 }, ...styles }}
            text={text}
        />
    );
};
